import { User, CreateUserRequest, UpdateUserRequest } from '../types/users.types';
import { BaseApiService } from '../../common/services/baseApiService';
import { API_URL } from '../../common/utils/util';

export class UsersService extends BaseApiService {
  static async getUsers(): Promise<User[]> {
    try {
      const response = await fetch(`${API_URL}/users`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const users: User[] = await this.handleResponse<User[]>(response);
      return users.map(user => ({
        ...user,
        createdAt: new Date(user.createdAt),
        updatedAt: new Date(user.updatedAt),
      }));
    } catch (error) {
      console.error('Get users error:', error);
      throw error;
    }
  }

  static async getUserById(id: string): Promise<User> {
    try {
      const response = await fetch(`${API_URL}/users/${id}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const user: User = await this.handleResponse<User>(response);
      return {
        ...user,
        createdAt: new Date(user.createdAt),
        updatedAt: new Date(user.updatedAt),
      };
    } catch (error) {
      console.error('Get user by id error:', error);
      throw error;
    }
  }

  static async createUser(userData: CreateUserRequest): Promise<User> {
    try {
      const response = await fetch(`${API_URL}/users`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(userData),
      });

      const user: User = await this.handleResponse<User>(response);
      return {
        ...user,
        createdAt: new Date(user.createdAt),
        updatedAt: new Date(user.updatedAt),
      };
    } catch (error) {
      console.error('Create user error:', error);
      throw error;
    }
  }

  static async updateUser(id: string, userData: UpdateUserRequest): Promise<User> {
    try {
      const response = await fetch(`${API_URL}/users/${id}`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(userData),
      });

      const user: User = await this.handleResponse<User>(response);
      return {
        ...user,
        createdAt: new Date(user.createdAt),
        updatedAt: new Date(user.updatedAt),
      };
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  }

  static async deleteUser(id: string): Promise<void> {
    try {
      const response = await fetch(`${API_URL}/users/${id}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders(),
      });

      await this.handleResponseWithoutData(response);
    } catch (error) {
      console.error('Delete user error:', error);
      throw error;
    }
  }
} 